<div [class]="containerClass">
  <div
    class="tw-bg-teal-850/80 tw-border-b-2 tw-border-t-0 tw-border-r-0 tw-border-l-0 tw-border-b-dt-today-300 tw-rounded-xl tw-p-4 tw-flex tw-flex-col tw-justify-center tw-gap-1 tw-shadow-drop-dark"
  >
    <!--    Header-->
    <div class="tw-flex tw-gap-2 tw-items-center">
      <icon [name]="'route'" [size]="6" [currentColor]="'white'"></icon>
      <span class="tw-text-white tw-font-semibold tw-text-base tw-uppercase">{{
        taskTitle | i18n
      }}</span>
      @if (bottomAction !== "none") {
        <button
          class="tw-ml-auto"
          type="button"
          (click)="goBackToGuide()"
          [attr.aria-label]="'closeAndReturnToGuide' | i18n"
        >
          <icon [name]="'x-close'" [size]="5" [currentColor]="'white'"></icon>
        </button>
      }
    </div>
    <div>
      <p class="tw-text-white tw-font-medium tw-text-base">
        {{ taskDescription | i18n }}
      </p>
      @if (subTaskDescription) {
        <p class="tw-text-white tw-font-medium tw-text-[14px]">
          {{ subTaskDescription | i18n }}
        </p>
      }
    </div>
    <div class="tw-flex tw-justify-between tw-items-center tw-w-full">
      @if (currentStep) {
        <div class="tw-flex tw-flex-row tw-items-center tw-gap-[6px] tw-w-[42px] tw-h-[14px]">
          @for (step of steps; track step; let i = $index) {
            <div
              [ngClass]="[
                'tw-rounded-full',
                'tw-inline-block',
                'tw-w-[6px]',
                'tw-h-[6px]',
                i + 1 === currentStep ? 'tw-bg-dt-custom-teal-9' : 'tw-bg-dt-slate-7',
              ]"
            ></div>
          }
        </div>
      }
      @if (bottomAction === "back") {
        <button
          (click)="goBackToGuide()"
          class="tw-font-bold tw-text-sm tw-text-white tw-bg-dt-custom-teal-11 tw-rounded-full tw-px-6 tw-py-3 tw-ml-auto"
        >
          {{ "backToGuide" | i18n }}
        </button>
      }
      @if (bottomAction === "return") {
        <!-- Intentionally non-interactive: instructs the user to press the × button above to close and return to the guide -->
        <div
          role="note"
          class="tw-font-bold tw-text-sm tw-text-white tw-bg-dt-custom-teal-11 tw-rounded-full tw-px-6 tw-py-3 tw-flex tw-items-center tw-gap-1"
        >
          <span>{{ "returnToGuidePrefix" | i18n }}</span>
          <span
            class="tw-bg-dt-surface-card tw-rounded-md tw-flex tw-items-center tw-pointer-events-none"
            aria-hidden="true"
          >
            <icon [name]="'x-close'" [size]="4" [currentColor]="'neutral-800'"></icon>
          </span>
          <span>{{ "returnToGuideSuffix" | i18n }}</span>
        </div>
      }
    </div>
  </div>
</div>
